<template>
  <div class="flex items-center justify-end gap-4">
    <SystemVersion v-if="!store.isProductionMode" class="version-container" />
    <LocaleButton />
    <div>
      <span v-if="type === UserType.INTERNAL">{{ departmentName }}</span>
      <span v-else>{{ dealerShortNameCn }}</span>
    </div>
    <User />
  </div>
</template>

<script lang="ts" setup>
import User from '@/layout/default/components/header/User.vue'
import LocaleButton from '@/layout/default/components/header/LocaleButton.vue'
import SystemVersion from '@/layout/default/components/header/SystemVersion.vue'
import { useCommonStore, UserType } from '@/store/useCommonStore'

const store = useCommonStore()

const type = computed(() => store.userInfo.type)
const departmentName = computed(() => store.userInfo.department)
const dealerShortNameCn = computed(() => store.userInfo.dealerShortNameCn)
</script>
